import { BundleId, AnyFunction } from '@mecontrol/common';

export interface BundleQueueItem {
    id: BundleId;
    deps: string[];
    factory: AnyFunction;
}

const bundleQueue: BundleQueueItem[] = [];

export function popBundle(): BundleQueueItem | undefined {
    return bundleQueue.pop();
}

export function queueBundle(id: BundleId, deps: string[], factory: AnyFunction): void {
    bundleQueue.push({ id, deps, factory });
}

export function queueLength(): number {
    return bundleQueue.length;
}
